import $ from 'jquery';
import { Formatter, PaymentCalculatorFactory } from '@dealersites/dealersite-js-core';

const configurePage = $('#configure-container-FLP');
const summaryPage = $('#container-summary');
const trimsPage = $('#container-trims');
if (trimsPage.length !== 0 || configurePage.length !== 0 || summaryPage.length !== 0) {
  const bottomBar = $('#bottom-bar');

  /**
   * Expands the bottom bar when the user presses the button with the
   * upwards arrow. This function also disables the responsive animation
   * on the bottom bar, so that the user can see all information about
   * the selected vehicle.
   *
   * @param {string}        selectButton
   * @param {string}        icon
   * @param {string}        height
   */
  function toggleBottomBar(selectButton, icon, height) {
    $(icon, selectButton).toggleClass('fa-chevron-circle-up fa-chevron-circle-down');

    bottomBar.stop().animate({ 'max-height': height });

    $('.RotatingWrapper').toggleClass('h-50');
    $('.RelatedTrims').toggleClass('col-4 col-12');
    $('.BottomBarBtnNext').toggleClass('col-4 col-12');
    $('.RotatingWrapper .RotatingContent').toggleClass('pb-4 flex-column flex-md-row col-4 col-12');
    $('.RotatingWrapper .RotatingContent div').toggleClass('RotatingWords');
    $('.RotatingWrapper .RotatingContent div div').toggleClass('RotatingWords');
  }

  $('.BottomBarExpand button').click(function (e) {
    if (e.target.classList.contains('fa-chevron-circle-up')) {
      toggleBottomBar(this, '.fa-chevron-circle-up', '400px');
    } else if (e.target.classList.contains('fa-chevron-circle-down')) {
      toggleBottomBar(this, '.fa-chevron-circle-down', '200px');
    }
  });



  // Updates the financing calculations when user selects a financing term
  $('#bottom-bar-financing-terms').on('change', function () {
    const $financeCalcResult = $('#bottom-bar--finance .finance');
    const $financeCalcRate = $('#bottom-bar--finance .bottom-bar-financing-value');

    const selectedOption = $('#bottom-bar-financing-terms option:selected');
    const selectedTerm = selectedOption.val();
    const selectedRate = selectedOption.data('rate');

    const calcInputs = {
      price: $financeCalcResult.data('price'),
      down: $financeCalcResult.data('down'),
      term: selectedTerm,
      rate: selectedRate,
      tradein: $financeCalcResult.data('tradein'),
      tax: 0,
    };

    const financeCalc = PaymentCalculatorFactory.createCalculator('finance', calcInputs);
    financeCalc.calculate();

    $financeCalcResult.text(Formatter.price(financeCalc.payments.weekly, 2));
    $financeCalcRate.text(selectedRate.toFixed(2));
  });

  // Updates the leasing calculations when user selects a leasing term
  $('#bottom-bar-leasing-terms').on('change', function () {
    const $leaseCalcResult = $('#bottom-bar--lease .lease');
    const $leaseCalcRate = $('#bottom-bar--lease .bottom-bar-leasing-value');

    const selectedOption = $('#bottom-bar-leasing-terms option:selected');
    const selectedTerm = selectedOption.val();
    const selectedRate = selectedOption.data('rate');

    const calcInputs = {
      price: $leaseCalcResult.data('price'),
      down: $leaseCalcResult.data('down'),
      term: selectedTerm,
      rate: selectedRate,
      tradein: $leaseCalcResult.data('tradein'),
      tax: 0,
    };

    const leaseCalc = PaymentCalculatorFactory.createCalculator('lease', calcInputs);
    leaseCalc.calculate();

    $leaseCalcResult.text(Formatter.price(leaseCalc.payments.weekly, 2));
    $leaseCalcRate.text(selectedRate.toFixed(2));
  });
}
